import React, {Component} from "react";
import {
    Breadcrumb,
    Button,
    ButtonGroup,
    Card,
    Col,
    Dropdown,
    Form,
    Nav,
    Pagination,
    Row,
    Table
} from "@themesberg/react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faCog, faHome, faSearch, faFilter, faChevronDown} from "@fortawesome/free-solid-svg-icons";
import {Routes} from "../../routes";
import {BeatLoader} from "react-spinners";
import {connect} from "react-redux";
import {getAllocatedLoans} from "../../actions/loans";
import {DevicesModelDialog} from "./components/DevicesModelDialog";
import {SchedulesModelDialog} from "./components/SchedulesModelDialog";
import FilterLoanStatus from "./components/FilterLoanStatus";
import FilterPaymentFreq from "./components/FilterPaymentFreq";
import FilterRender from "./components/FilterRender";
import FilterApplicationStatus from "./components/FilterApplicationStatus";
import {StartCase} from 'react-lodash';
import authorization from "../../helpers/authorization";

const TableRow = (props) => {
    const {
        index, bank, downPayment, totalLoanAmount, minScore, paymentFrequency, devices,
        offeringDate, loanStatus, showDevices, setDevices, customer,
    } = props;

    return (
        <tr>
            <td>
                <a href={authorization("IC_READ") ? `/clients/${customer.intelligraCustomerId}/details` : "#"}>
                    <Card.Link href="#" className="text-primary fw-bold">{(index + 1)}</Card.Link>
                </a>
            </td>
            <td className="fw-bold">
                <a href={authorization("IC_READ") ? `/clients/${customer.intelligraCustomerId}/details` : "#"}>
                    <StartCase
                        string={`${customer.customerName} ${customer.customerSurname}`?.toLocaleLowerCase()}/>
                </a>
            </td>
            <td className="fw-bold">
                {customer?.gender.toLowerCase() === 'm' ? 'Male' : 'Female'}
            </td>
            <td className="fw-bold">
                <a href={authorization("IC_READ") ? `/clients/${customer.intelligraCustomerId}/details` : "#"}>
                    {customer.msisdn}
                </a>
            </td>
            <td className="fw-bold">
                <a href={authorization("IC_READ") ? `/clients/${customer.intelligraCustomerId}/details` : "#"}>
                    {bank ? bank.name ?? bank.bankName : "Intelligra"}
                </a>
            </td>
            <td className="fw-bold">
                <a href={authorization("IC_READ") ? `/clients/${customer.intelligraCustomerId}/details` : "#"}>
                    {minScore ?? "R1"}
                </a>
            </td>
            <td className="fw-bold">
                <Button size={'sm'} onClick={() => {
                    showDevices();
                    setDevices(devices);
                }}
                        variant={'light'}>Device(s): {devices && devices.length}</Button>
            </td>
            {/* <td className="fw-bold">
                <Button size={'sm'} variant={'light'} onClick={() => {
                    showSchedules();
                    setSchedules(paymentSchedules);
                }}>Schedules</Button>
            </td> */}
            <td className="fw-bold">{paymentFrequency}</td>
            <td className="fw-bold">{totalLoanAmount.toLocaleString()}</td>
            <td className="fw-bold">{downPayment.toLocaleString()}</td>
            {/* <td className="fw-bold">{loanBalance.toLocaleString()}</td> */}
            {/* <td className="fw-bold">{paidAmount.toLocaleString()}</td> */}
            <td className="fw-bold">{loanStatus}</td>
            <td className="fw-bold">{
                (new Date(offeringDate)).toLocaleString()
            }</td>
        </tr>
    );
};

class AllocatedLoans extends Component {
    state = {
        loading: true,
        showDevices: false,
        showSchedules: false,
        status: null,
        selectedFreq: null,
        selectedRender: null,
        selectedGender: null,
        getDevices: [],
        getSchedules: [],
        loansList: null,
        searchMsisdn: '',
        searchName: '',
        searchError: '',
    };

    componentDidMount = async () => {
        this.setState({loading: true,});
        const {getAllocatedLoans} = this.props;
        await getAllocatedLoans(0, 25);
        this.setState({loading: false,});
    }

    componentDidUpdate = async (prevProps, prevState, snapshot) => {
        const prevStatus = prevState.status;
        const {status} = this.state;
        if (prevStatus !== status) {
            //
        }
    }
    //
    setStatus = (status) => {
        const {loans} = this.props;
        const source = loans?.content ?? [];
        const _loans = source.filter((item) => item.loanStatus?.toLocaleLowerCase().includes(status?.toLocaleLowerCase()));
        this.setState({status: status, loansList: _loans,});
    }
    //
    selectedFreq = (selectedFreq) => {
        const {loans} = this.props;
        const source = loans?.content ?? [];
        const _loans = source.filter((item) => item.paymentFrequency?.toLocaleLowerCase().includes(selectedFreq?.toLocaleLowerCase()));
        this.setState({selectedFreq: selectedFreq, loansList: _loans,});
    }
    //
    setRender = (selectedRender) => {
        const {loans} = this.props;
        const source = loans?.content ?? [];
        const _loans = source.filter((item) => item.bank?.id?.toString()?.toLocaleLowerCase().includes(selectedRender?.id?.toString()?.toLocaleLowerCase()));
        this.setState({selectedRender: selectedRender, loansList: _loans,});
    }
    //
    setGender = (gender) => {
        const {loans} = this.props;
        const source = loans?.content ?? [];
        if (!gender) {
            this.setState({ selectedGender: null, loansList: null });
            return;
        }
        const g = (gender || '').toString().toLowerCase();
        const _loans = source.filter((item) => (item.customer?.gender || '').toString().toLowerCase() === g);
        this.setState({ selectedGender: gender, loansList: _loans });
    }
    //
    handleSearch = async () => {
        const {searchMsisdn, searchName} = this.state;
        if (!searchMsisdn.trim() && !searchName.trim()) {
            this.setState({searchError: 'Please enter at least an MSISDN or a Name.'});
            return;
        }
        const size = this.props.loans?.size ?? 25;
        this.setState({loading: true, loansList: null, searchError: ''});
        await this.props.getAllocatedLoans(0, size, searchMsisdn.trim() || null, searchName.trim() || null);
        this.setState({loading: false});
    }

    handleReset = async () => {
        const size = this.props.loans?.size ?? 25;
        this.setState({searchMsisdn: '', searchName: '', searchError: '', loading: true, loansList: null});
        await this.props.getAllocatedLoans(0, size);
        this.setState({loading: false});
    }
    //
    showDevices = () => {
        this.setState({showDevices: true,});
    }
    //
    showSchedule = () => {
        this.setState({showSchedules: true});
    }
    //
    hideSchedule = () => {
        this.setState({showSchedules: false, getSchedules: [],});
    }
    //
    hideDevices = () => {
        this.setState({showDevices: false, getDevices: [],});
    }
    //
    setDevices = (devices) => {
        this.setState({
            getDevices: devices,
        });
    }
    //
    setPaymentSchedules = (schedules) => {
        this.setState({
            getSchedules: schedules,
        });
    }

    goToPage = async (page) => {
        const size = this.props.loans?.size ?? 25;
        const {searchMsisdn, searchName} = this.state;
        this.setState({ loading: true, loansList: null });
        await this.props.getAllocatedLoans(page, size, searchMsisdn.trim() || null, searchName.trim() || null);
        this.setState({ loading: false });
    }

    goPrev = async (current) => {
        if (current > 0) {
            await this.goToPage(current - 1);
        }
    }

    goNext = async (current, totalPages) => {
        if (current + 1 < totalPages) {
            await this.goToPage(current + 1);
        }
    }

    handlePageSelect = async (e) => {
        const value = parseInt(e.target.value, 10);
        if (!isNaN(value)) {
            await this.goToPage(value - 1);
        }
    }

    handleSizeSelect = async (e) => {
        const size = parseInt(e.target.value, 10);
        if (!isNaN(size)) {
            const {searchMsisdn, searchName} = this.state;
            this.setState({ loading: true, loansList: null });
            await this.props.getAllocatedLoans(0, size, searchMsisdn.trim() || null, searchName.trim() || null);
            this.setState({ loading: false });
        }
    }

    renderPaginationItems = (currentPage, totalPages) => {
        const items = [];
        const maxPagesToShow = 7;

        if (totalPages <= maxPagesToShow) {
            // Show all pages if total is small
            for (let i = 0; i < totalPages; i++) {
                items.push(
                    <Pagination.Item
                        key={`page-btn-${i+1}`}
                        active={i === currentPage}
                        onClick={() => this.goToPage(i)}
                    >
                        {i + 1}
                    </Pagination.Item>
                );
            }
        } else {
            // Always show first page
            items.push(
                <Pagination.Item
                    key="page-btn-1"
                    active={currentPage === 0}
                    onClick={() => this.goToPage(0)}
                >
                    1
                </Pagination.Item>
            );

            // Determine the range of pages to show
            let startPage, endPage;

            if (currentPage <= 3) {
                // Near the beginning
                startPage = 1;
                endPage = 4;
            } else if (currentPage >= totalPages - 4) {
                // Near the end
                startPage = totalPages - 5;
                endPage = totalPages - 1;
            } else {
                // In the middle
                startPage = currentPage - 1;
                endPage = currentPage + 1;
            }

            // Add ellipsis after first page if needed
            if (startPage > 1) {
                items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
            }

            // Add middle pages
            for (let i = startPage; i <= endPage; i++) {
                items.push(
                    <Pagination.Item
                        key={`page-btn-${i+1}`}
                        active={i === currentPage}
                        onClick={() => this.goToPage(i)}
                    >
                        {i + 1}
                    </Pagination.Item>
                );
            }

            // Add ellipsis before last page if needed
            if (endPage < totalPages - 2) {
                items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
            }

            // Always show last page
            items.push(
                <Pagination.Item
                    key={`page-btn-${totalPages}`}
                    active={currentPage === totalPages - 1}
                    onClick={() => this.goToPage(totalPages - 1)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        return items;
    }

    //
    render() {
        const {loading, showDevices, getDevices, showSchedules, getSchedules, loansList} = this.state;
        const {loans, user} = this.props;
        const isPartnerUser = (user?.userPartnerType ?? "").toLowerCase() !== 'i';
        const pageNumber = loans?.number ?? 0;
        const pageSize = loans?.size ?? 25;
        const totalPages = loans?.totalPages ?? 0;
        const totalElements = loans?.totalElements ?? 0;
        const numberOfElements = loans?.numberOfElements ?? (loans?.content?.length ?? 0);
        const isFirst = loans?.first ?? pageNumber === 0;
        const isLast = loans?.last ?? (pageNumber + 1 >= totalPages);
        let _loans = loansList ?? (loans?.content ?? []);

        return (
            <>
                <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-xl-0">
                        <Breadcrumb className="d-none d-md-inline-block"
                                    listProps={{className: "breadcrumb-dark breadcrumb-transparent"}}>
                            <Breadcrumb.Item href={Routes.DashboardOverview.path}><FontAwesomeIcon
                                icon={faHome}/></Breadcrumb.Item>
                            <Breadcrumb.Item active>Allocated loans.</Breadcrumb.Item>
                        </Breadcrumb>
                        <h4>Allocated loans.</h4>
                    </div>
                    <div className="btn-toolbar mb-2 mb-md-0">
                        &nbsp;
                    </div>
                </div>

                <div className="table-settings mb-4">
                    <Row className="g-2 mb-3 align-items-end">
                        <Col md={4}>
                            <Form.Label className="mb-1 fw-bold small">MSISDN</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Search by MSISDN"
                                value={this.state.searchMsisdn}
                                onChange={(e) => this.setState({searchMsisdn: e.target.value, searchError: ''})}
                            />
                        </Col>
                        <Col md={4}>
                            <Form.Label className="mb-1 fw-bold small">Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Search by Name"
                                value={this.state.searchName}
                                onChange={(e) => this.setState({searchName: e.target.value, searchError: ''})}
                            />
                        </Col>
                        <Col md={2}>
                            <Button variant="primary" onClick={this.handleSearch} className="w-100">
                                <FontAwesomeIcon icon={faSearch} className="me-1"/> Search
                            </Button>
                        </Col>
                        <Col md={2}>
                            <Button variant="outline-secondary" onClick={this.handleReset} className="w-100">
                                Reset
                            </Button>
                        </Col>
                        {this.state.searchError && (
                            <Col md={12}>
                                <small className="text-danger">{this.state.searchError}</small>
                            </Col>
                        )}
                    </Row>
                    <Row className="g-3 justify-content-between align-items-center">
                        <Col md={8} className="mb-2 mb-md-0">
                            <Row className="g-2 g-md-3 filters-row">
                                { !isPartnerUser && (
                                    <>
                                        <Col xs={12} sm={6} md={3} className="position-relative mb-2 mb-md-0"><FilterLoanStatus selectStatus={this.setStatus}/></Col>
                                        <Col xs={12} sm={6} md={3} className="position-relative mb-2 mb-md-0"><FilterApplicationStatus selectStatus={this.setStatus}/></Col>
                                        <Col xs={12} sm={6} md={3} className="position-relative mb-2 mb-md-0"><FilterRender selectRender={this.setRender}/></Col>
                                    </>
                                )}
                                <Col xs={12} sm={6} md={3} className="position-relative mb-2 mb-md-0"><FilterPaymentFreq selectedFreq={this.selectedFreq}/></Col>
                                <Col xs={12} sm={6} md={3} className="position-relative mb-2 mb-md-0">
                                    <Dropdown>
                                        <Dropdown.Toggle as={Button} variant="primary" className={'py-1'}>
                                            <FontAwesomeIcon icon={faFilter} className="me-2"/>
                                            {this.state.selectedGender ? `Gender: ${this.state.selectedGender === 'm' ? 'Male' : 'Female'}` : 'Gender'}
                                            <span className="icon icon-small ms-1"><FontAwesomeIcon icon={faChevronDown}/></span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="dashboard-dropdown dropdown-menu-left mt-1">
                                            <Dropdown.Item onClick={() => this.setGender(null)} active={this.state.selectedGender === null}>All</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.setGender('m')} active={this.state.selectedGender === 'm'}>Male</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.setGender('f')} active={this.state.selectedGender === 'f'}>Female</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={1} className="ps-md-0 text-end mb-2 mb-md-0">
                            <Dropdown as={ButtonGroup}>
                                <Dropdown.Toggle split as={Button} variant="link" className="text-dark m-0 p-0">
                                <span className="icon icon-sm icon-gray">
                                  <FontAwesomeIcon icon={faCog}/>
                                </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-right">
                                    <Dropdown.Item className="fw-bold text-dark">Show</Dropdown.Item>
                                    <Dropdown.Item className="d-flex fw-bold" onClick={() => this.handleSizeSelect({ target: { value: 10 } })}>
                                        10 {pageSize === 10 ? <span className="icon icon-small ms-auto"><FontAwesomeIcon icon={faCheck}/></span> : null}
                                    </Dropdown.Item>
                                    <Dropdown.Item className="d-flex fw-bold" onClick={() => this.handleSizeSelect({ target: { value: 25 } })}>
                                        25 {pageSize === 25 ? <span className="icon icon-small ms-auto"><FontAwesomeIcon icon={faCheck}/></span> : null}
                                    </Dropdown.Item>
                                    <Dropdown.Item className="d-flex fw-bold" onClick={() => this.handleSizeSelect({ target: { value: 50 } })}>
                                        50 {pageSize === 50 ? <span className="icon icon-small ms-auto"><FontAwesomeIcon icon={faCheck}/></span> : null}
                                    </Dropdown.Item>
                                    <Dropdown.Item className="d-flex fw-bold" onClick={() => this.handleSizeSelect({ target: { value: 100 } })}>
                                        100 {pageSize === 100 ? <span className="icon icon-small ms-auto"><FontAwesomeIcon icon={faCheck}/></span> : null}
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    </Row>
                </div>

                <Card border="light" className="table-wrapper table-responsive shadow-sm">
                    <Card.Body className="">
                        <Table responsive striped bordered className="user-table align-items-center">
                            <thead>
                            <tr>
                                <th className="border-bottom">#</th>
                                <th className="border-bottom">Customer Name</th>
                                <th className="border-bottom">Gender</th>
                                <th className="border-bottom">Customer Telephone</th>
                                <th className="border-bottom">Lender</th>
                                <th className="border-bottom">Min Score</th>
                                <th className="border-bottom">Device(s)</th>
                                {/* <th className="border-bottom">Schedules</th> */}
                                <th className="border-bottom">Payment Frequency</th>
                                <th className="border-bottom">Total Loan Amount</th>
                                <th className="border-bottom">Down Payment</th>
                                {/* <th className="border-bottom">Loan Balance</th> */}
                                {/* <th className="border-bottom">Paid Amount</th> */}
                                <th className="border-bottom">Loan Status</th>
                                <th className="border-bottom">Offering Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                loading ? (
                                    <tr>
                                        <td colSpan="14" align="center"><BeatLoader color="#000" size="8"/></td>
                                    </tr>
                                ) : _loans != null && _loans.length > 0 ?
                                    _loans.map((loan, i) => <TableRow {...loan}
                                                                      index={i}
                                                                      showDevices={this.showDevices}
                                                                      showSchedules={this.showSchedule}
                                                                      hideDevices={this.hideDevices}
                                                                      openDevicesModel={showDevices}
                                                                      openSchedulesModel={showSchedules}
                                                                      setDevices={this.setDevices}
                                                                      setSchedules={this.setPaymentSchedules}
                                                                      key={`page-visit-${loan.loanId || loan.id || i}`}/>) : (
                                        <tr>
                                            <td colSpan="14" align="center">No results found.</td>
                                        </tr>
                                    )
                            }
                            </tbody>
                        </Table>
                    </Card.Body>
                    <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
                        <Nav className="align-items-center">
                            <Pagination className="mb-2 mb-lg-0">
                                <Pagination.Prev onClick={() => this.goPrev(pageNumber)} disabled={isFirst}>
                                    Previous
                                </Pagination.Prev>
                                {this.renderPaginationItems(pageNumber, totalPages)}
                                <Pagination.Next onClick={() => this.goNext(pageNumber, totalPages)} disabled={isLast}>
                                    Next
                                </Pagination.Next>
                            </Pagination>
                            <div className="ms-3 d-flex align-items-center">
                                <span className="me-2">Size</span>
                                <Form.Select size="sm" value={pageSize} onChange={this.handleSizeSelect} style={{ width: 100 }}>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </Form.Select>
                            </div>
                        </Nav>
                        <small className="fw-bold">
                            {(() => { const start = totalElements === 0 ? 0 : (pageNumber * pageSize) + 1; const end = (pageNumber * pageSize) + numberOfElements; return `Showing ${start}-${end} of ${totalElements} entries`; })()}
                        </small>
                    </Card.Footer>
                </Card>
                <DevicesModelDialog show={showDevices} close={this.hideDevices} devices={getDevices}/>
                <SchedulesModelDialog show={showSchedules} close={this.hideSchedule} schedules={getSchedules}/>
            </>
        );
    }
}

const mapStateProps = (state) => {
    const {loans, error,} = state.loans;
    const {user} = state.profile || {};
    return {loans, error, user};
}

export default connect(mapStateProps, {getAllocatedLoans})(AllocatedLoans);
